import {
  collection,
  doc,
  getDocs,
  updateDoc,
  query,
  where
} from "firebase/firestore";
import { database } from "./firebase";

export const getLocations = async () => {
  const docRef = query(
    collection(database, "locations"),
    where("access", "==", "public")
  );

  const snapshot = await getDocs(docRef);

  let locations = [];

  snapshot.forEach((doc) => {
    if (!doc.data().actions?.deletedAt) {
      locations.push({
        ...doc.data(),
        documentId: doc.id
      });
    }
  });

  return locations;
};

export const updateCompliant = async (documentId, data) => {
  await updateDoc(
    doc(database, "complaints", documentId),
    {
      assets: data
    },
    { merge: true }
  );
  return documentId;
};
